module.exports = __webpack_public_path__ + "static/goldm_3_p-487f1765bfd4df6b91ad95dbdcd4910c.mp4";